import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export function transformSubDepartmentUIToModel(
  values: Partial<EmployeeFormFields>
): Partial<EmployeeFormFields> {
  const { subDepartment, ...rest } = values;

  // Only include subDepartment if it has a value
  if (subDepartment) {
    return values;
  }

  return rest;
}
